import { SerializableObject } from './serializable-object';


export class AdminDomain extends SerializableObject {
  public id: string;
  public createdUtc: Date;
  public modifiedUtc: Date;
  public createdBy: string;
  public modifiedBy: string;
  public name: string;
  public active: boolean;
  public description: string;
}
